import { render, staticRenderFns } from "./PrescriptionPaymentForm.vue?vue&type=template&id=7794e52a&"
import script from "./PrescriptionPaymentForm.vue?vue&type=script&lang=js&"
export * from "./PrescriptionPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports